import { render, staticRenderFns } from "./FrontHeader.vue?vue&type=template&id=65f5a8e2&scoped=true&"
import script from "./FrontHeader.vue?vue&type=script&lang=js&"
export * from "./FrontHeader.vue?vue&type=script&lang=js&"
import style0 from "./FrontHeader.vue?vue&type=style&index=0&id=65f5a8e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f5a8e2",
  null
  
)

export default component.exports